 export const skillsData = [
    'HTML',
    'CSS',
    'Bootstrap',
    'Tailwind',
    'Javascript',
    'React',
    'Node',
    'Express',
    'MongoDB',
]
